import React, { useState } from 'react';
import Button from "@mui/material/Button";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import SqftStore from "../../../canvas/store/sqftStore";

const PhotoViewButton = ({ isMobile }) => {
  const [isPhotoViewActive, setIsPhotoViewActive] = useState(false);

  const toggleCameraView = () => {
    const viewGL = SqftStore.viewGL;
    const methodName = isPhotoViewActive ? 'applyDesignViewPreset' : 'applyPhotoViewPreset';

    if (!viewGL || typeof viewGL[methodName] !== 'function') {
      return;
    }

    viewGL[methodName]();
    setIsPhotoViewActive(!isPhotoViewActive);
  };

  return (
    <Button
      className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
      style={{ backgroundColor: "white" }}
      startIcon={<CameraAltIcon />}
      onClick={toggleCameraView}
    >
      {isMobile
        ? ""
        : isPhotoViewActive
          ? <FormattedMessage id="sqft.popup.button.designView" defaultMessage="Design View" />
          : <FormattedMessage id="sqft.popup.button.photoView" defaultMessage="Photo View" />}
    </Button>
  );
};

const mapStateToProps = (store) => ({
  isMobile: store.serverState.isMobile,
});

export default connect(mapStateToProps)(PhotoViewButton);
